export default {
  // 输入标题
  transferDirection: "转账方向",
  currencyToken: "币种/代币合约",
  tags: "标签",
  functionSwitch: "功能开关",
  time: "时间",

  // 占位符
  pleaseSelect: "请选择",
  startDate: "开始日期",
  endDate: "结束日期",

  // 按钮和链接
  transactionQuantityConfig: "交易数量配置",
  moreFilters: "更多筛选项",
  cancel: "取消",
  confirm: "确定",

  // 转账方向选项
  outflow: "流出",
  inflow: "流入",
  bidirectional: "双向",

  // 功能开关选项
  surveyData: "调证数据",
  surveyDataTooltip: "可扩展出已上传调证的相关数据",
  firstInflow: "首笔流入",
  firstInflowTooltip: "扩展增加显示首笔主币流入地址",
  swapContract: "swap合约",
  swapContractTooltip: "可扩展出swap合约交易数据",

  // 币种分类
  commonCurrency: "常用币种",
  contractToken: "合约代币",
  all: "全部",

  // 消息提示
  currencyUpdateSuccess: "币种修改成功",
  timeUpdateSuccess: "时间修改成功",
  tagUpdateSuccess: "标签修改成功",
  switchUpdateSuccess: "开关修改成功",
  directionUpdateSuccess: "转账方向修改成功",
  filterSuccess: "筛选成功",

  // 数据提示
  noDataFound: "未找到符合搜索内容的数据 请修正后重试",

  // 标签提示
  exchangeAddressTooltip: "扩展地址只显示交易所相关标签的地址",
  maliciousAddressTooltip: "扩展地址只显示恶意标签的地址",
};
